(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("stockSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 499,
                    parameters: parms || {}
                });
            },
            listComponents: function (parms) {
                return $ihttp.post({
                    method: 487,
                    parameters: parms || {}
                });
            },
            searchItem: function (setting) {
                return $ihttp.post({
                    method: 455,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
